// Sala de reunião: piso de madeira, mesa comprida com oito cadeiras (quatro de cada lado), tela
// de projeção na parede do alto, quadro branco de rodinhas e um canto com estante e
// impressora. A porta fica embaixo.

import type { RoomMap } from '../../core/world.js';

export const REUNIAO: RoomMap = {
  id: 'reuniao',
  kind: 'meeting',
  name: 'Sala de reunião',
  // m = madeira
  floor: Array.from({ length: 9 }, () => 'mmmmmmmmmmmmmm'),
  legend: { m: 'madeira' },
  items: [
    // parede norte: relógio, tela de projeção, quadro de avisos e janela
    { item: 'relogio', x: 1, y: 0 },
    { item: 'tela-projecao', x: 6, y: 0 },
    { item: 'quadro-avisos', x: 10, y: 0 },
    { item: 'janela', x: 11, y: 0 },
    // mesa de reunião com cadeiras dos dois lados (os pontos ficam nas cadeiras)
    { item: 'mesa-reuniao', x: 5, y: 3 },
    { item: 'cadeira-reuniao', x: 5, y: 2 },
    { item: 'cadeira-reuniao', x: 6, y: 2 },
    { item: 'cadeira-reuniao', x: 7, y: 2 },
    { item: 'cadeira-reuniao', x: 8, y: 2 },
    { item: 'cadeira-reuniao', x: 5, y: 5 },
    { item: 'cadeira-reuniao', x: 6, y: 5 },
    { item: 'cadeira-reuniao', x: 7, y: 5 },
    { item: 'cadeira-reuniao', x: 8, y: 5 },
    // quadro branco de rodinhas, estante e impressora
    { item: 'quadro-branco', x: 1, y: 3 },
    { item: 'estante-dupla', x: 11, y: 2 },
    { item: 'impressora', x: 10, y: 6 },
    // cantos: planta, luminária, bebedouro e vasos
    { item: 'planta-grande', x: 13, y: 1 },
    { item: 'luminaria-chao', x: 12, y: 6 },
    { item: 'bebedouro', x: 13, y: 4 },
    { item: 'planta-vaso', x: 0, y: 8 },
    { item: 'vaso-alto', x: 13, y: 8 },
  ],
  doors: [{ x: 6, y: 8 }],
};
